import {useMutation} from "@tanstack/react-query";

import {removeClientContactMutationOptions} from "./remove-client-contact.mutation-options";

export function useRemoveClientContact(clientId: string) {
  return useMutation(removeClientContactMutationOptions(clientId));
}
